var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#DAE0E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30.9C20 30.343 20.2107 29.8089 20.5858 29.4151C20.9609 29.0212 21.4696 28.8 22 28.8C22.5304 28.8 23.0391 29.0212 23.4142 29.4151C23.7893 29.8089 24 30.343 24 30.9C24 31.457 23.7893 31.9911 23.4142 32.3849C23.0391 32.7788 22.5304 33 22 33C21.4696 33 20.9609 32.7788 20.5858 32.3849C20.2107 31.9911 20 31.457 20 30.9ZM20 22.5C20 21.943 20.2107 21.4089 20.5858 21.0151C20.9609 20.6212 21.4696 20.4 22 20.4C22.5304 20.4 23.0391 20.6212 23.4142 21.0151C23.7893 21.4089 24 21.943 24 22.5C24 23.057 23.7893 23.5911 23.4142 23.9849C23.0391 24.3787 22.5304 24.6 22 24.6C21.4696 24.6 20.9609 24.3787 20.5858 23.9849C20.2107 23.5911 20 23.057 20 22.5ZM20 14.1C20 13.543 20.2107 13.0089 20.5858 12.6151C20.9609 12.2212 21.4696 12 22 12C22.5304 12 23.0391 12.2212 23.4142 12.6151C23.7893 13.0089 24 13.543 24 14.1C24 14.657 23.7893 15.1911 23.4142 15.5849C23.0391 15.9788 22.5304 16.2 22 16.2C21.4696 16.2 20.9609 15.9788 20.5858 15.5849C20.2107 15.1911 20 14.657 20 14.1Z",
    fill: "#271E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DotsIcon);
export default __webpack_public_path__ + "static/media/3-dots-icon.a4349226593e9b1f051fa8d5a18df873.svg";
export { ForwardRef as ReactComponent };